import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Tab } from 'semantic-ui-react';
import { useQuery } from '@apollo/client';

import { Flex } from 'Components/Base';
import Text from 'Components/Base/Text';
import { getStudentProfile } from 'GraphQL/LSP/query/Profile.query';
import AllAssignmentsRoute from 'Routes/LSP/Syllabuses/Routes/AllAssignmentsRoute';
import Loading from 'Components/Loading';
import getDisplayName from 'Util/LSP/getDisplayName';

const panes = (userId) => [
  {
    menuItem: 'แผนการเรียน',
    render: () => <AllAssignmentsRoute userId={userId} />,
  },
];

const StudentProfileDetailsRoute = (props) => {
  const userId = _.get(props, 'match.params.id');
  const { loading, error, data } = useQuery(getStudentProfile, {
    variables: {
      userId,
    },
    fetchPolicy: 'network-only',
  });
  if (loading) return <Loading dimmer={false} loaderProps={{ active: true, inline: 'centered' }} />;
  return (
    <Fragment>
      <Flex justifyContent="space-between" mb={2}>
        <Text.Header>{getDisplayName(data && data.boStudentProfile)}</Text.Header>
      </Flex>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes(userId)} />
    </Fragment>
  );
};

StudentProfileDetailsRoute.propTypes = {};

export default StudentProfileDetailsRoute;
